// Lightweight error reporter.
//
// The previous implementation globally monkey-patched console.warn/console.error
// and POSTed every error to `/api/client-errors`, an endpoint that does not
// exist on this static marketing site, so every report 404'd (and the failed
// POST logged another console.error, which was then re-intercepted). That was
// pure template plumbing. This stub keeps the small API the error boundaries
// rely on (`errorReporter.report(...)`) and simply logs to the console.

export const errorReporter = {
  report(error: Record<string, unknown>): void {
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
      console.error('[AwayFX] Captured error:', error?.message ?? error);
    }
  },
};
